// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2OUXb","rootCenter":"LoadMoreObserver_rootCenter__1Q-Bu","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__24qfS"};